const initReadMore = () => {
  // Select buttons
  const readMoreBtns =
    document.querySelectorAll<HTMLButtonElement>('.js-btn-read-more');

  // Toggle function
  const toggle = ({ currentTarget }: Event) => {
    const button = currentTarget as HTMLButtonElement;
    const { rel } = button.dataset;
    if (rel) {
      button.classList.toggle('active');
      const readMoreText = document.getElementById(rel);
      readMoreText?.classList.toggle('active');
    }
  };

  // Attach event listeners
  readMoreBtns.forEach(btn => btn.addEventListener('click', toggle));
};

export default initReadMore;
